<template>
<div>
	<div v-for="day in scheduleDays">
		<h5><router-link :to="'/schedule/daily/' + day.day">
			{{ day.dayPretty }}
		</router-link></h5>

		<table-list	
			record-name="Event"
			:records="day.events"
			:hide-record-count="true"
			:fields="[
				{label: 'Employee', key: 'employeeName'},
				{label: 'Start', key: 'startTime'},
				{label: 'End', key: 'endTime'},
				{label: 'Role', key: 'role'}
			]">
		</table-list>
	</div>
</div>
</template>

<script type="text/javascript">
import TableList from "@/components/TableList"	

export default {
	components: {
		TableList
	},
	props: ["serviceId","projectId","daysBack"],
	data() {
		return {
			scheduleDays: []
		}
	},
	watch: {
		serviceId() {
			this.fetchJobEvents()
		},
		projectId() {
			this.fetchJobEvents()
		}
	},
	computed: {
		jobType() {
			if (this.serviceId)
				return "service"
			else
				return "project"
		},
	},
	methods: {
		mutateEvents(events) {
			let vm = this

			return events.map(event => {
				event.employeeName = event.User.first_name + " " + event.User.last_name
				event.startTime = vm.formatDateTimeToLocal(event.start_time,"time")
				event.endTime = vm.formatDateTimeToLocal(event.end_time,"time")

				event.role = "Helper"
				if ("Service" in event && event.Service) 
					event.role = event.Service.assigned_to == event.user_id ? "Lead" : ""

				return event
			})
		},
		renderScheduleDays(events) {
			let days = [], vm = this

			events = this.mutateEvents(events)

			events.forEach(event => {
				let eventDay = vm.formatDateTimeToLocal(event.start_time,"YYYY-MM-DD")

				let dayExists = days.find(day => eventDay == day.day)

				if (!dayExists) {
					//push the new day to the array
					days.push({
						day: eventDay,
						dayPretty: vm.formatDateTimeToLocal(event.start_time,"full-date"),
						events: [event]
					})
				}
				else 
					dayExists.events.push(event)
			})

			return days
		},
		fetchJobEvents() {
			let vm = this

			let jobKey, jobId
			if (this.serviceId) {
				jobKey = "service_id"
				jobId = this.serviceId
			}
			else {
				jobKey = "job_id"
				jobId = this.projectId
			}

			let jobFields = ["id","slug","job_num","job_name","assigned_to"]

			let filters = [
				[jobKey,jobId],
				["user_id >",0]
			]

			if (this.daysBack) {
				filters.push(["start_time >",this.moment().subtract(this.daysBack,"days").format("YYYY-MM-DD")])
			}

			let params = {
				filters,
				include: [
					{
						model: "Service",
						fields: jobFields
					},
					{
						model: "Job",
						fields: jobFields
					},
					{
						model: "User",
						fields: ["id","slug","first_name","last_name"]
					}
				],
				orders: [
					["start_time","DESC"]
				]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {
				if (response.success) {
					//sort into days
					vm.scheduleDays = vm.renderScheduleDays(response.data)

					vm.$emit("scheduleDaysSet",vm.scheduleDays)
				}
			})
		}
	},
	created() {
		if (this.serviceId || this.projectId)
			this.fetchJobEvents()
	}
}
</script>